<wchfs-icon svgIcon="pso:pen_blue_m" size="24" (click)="onClick($event)"></wchfs-icon>
